export const COLOMBIA = [
  "300",
  "301",
  "302",
  "304",
  "305",
  "324",
  "302",
  "304",
  "304",
  "304",
  "305",
  "305",
  "310",
  "311",
  "312",
  "313",
  "314",
  "320",
  "321",
  "322",
  "323",
  "315",
  "316",
  "317",
  "318",
  "319",
  "324",
  "350",
  "351",
];

//https://en.wikipedia.org/wiki/List_of_dialling_codes_in_Brazil
export const BRAZIL = [
  //State of São Paulo
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",

  //States of Rio de Janeiro and Espírito Santo
  "21",
  "22",
  "23",
  "24",
  "25",

  //Espírito Santo
  "27",
  "28",
  "29",

  //State of Minas Gerais
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",

  //States of Paraná and Santa Catarina
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",

  //Santa Catarina
  "47",
  "48",
  "49",

  //State of Rio Grande do Sul
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",

  //Federal District
  "61",

  //Goiás
  "62",
  "64",

  //Tocantins
  "63",

  //Mato Grosso
  "65",
  "66",

  //Mato Grosso do Sul
  "67",

  //Acre
  "68",

  //Rondônia
  "69",

  //Bahia
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",

  //Sergipe
  "79",

  //Pernambuco
  "81",
  "87",

  //Alagoas
  "82",

  //Paraíba
  "83",

  //Rio Grande do Norte
  "84",

  //Ceará
  "85",
  "88",

  //Piauí
  "86",
  "89",

  //Pará
  "91",
  "93",
  "94",

  //Amazonas
  "92",
  "97",

  //Roraima
  "95",

  //Amapá
  "96",

  //Maranhão
  "98",
  "99",
];

export const MEXICO_SHORT = ["55", "81", "33"];

export const MEXICO_LONG = [
  "744",
  "449",
  "241",
  "624",
  "998",
  "461",
  "614",
  "330",
  "938",
  "656",
  "777",
  "667",
  "618",
  "646",
  "662",
  "462",
  "961",
  "932",
  "971",
  "370",
  "477",
  "668",
  "871",
  "669",
  "999",
  "686",
  "443",
  "631",
  "867",
  "951",
  "984",
  "320",
  "861",
  "222",
  "322",
  "899",
  "844",
  "444",
  "833",
  "664",
  "871",
  "229",
  "993",
  "350",
];

export const ARGENTINA = ["11", "22", "23", "24", "26", "29", "34", "35", "35", "37", "38", "40", "42", "62"];

export const AREA_CODES_BY_COUNTRY_CODE: Record<string, string[]> = {
  "57": COLOMBIA,
  "55": BRAZIL,
  "52": [...MEXICO_SHORT, ...MEXICO_LONG],
  "549": ARGENTINA,
};
